import _get from 'lodash/get';
import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { getInitialStyle } from './contextTitle.style';

export class ContextTitle extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Rectangle: {
          Label: {},
        },
      },
      getInitialStyle(),
    );
  }

  set data(value) {
    const title = _get(value, 'metadata.title', '');

    this.tag('Rectangle').tag('Label').text = title;
  }
}
